import { Button, Icon } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { usePersistentSelection } from 'site/Renderer/components/FilterFields/hooks/usePersistentSelection/usePersistentSelection'
import { useSiteState } from 'siteState/shared'
import { SelectAndLinkButtonProps } from './TableActions.types'

const SelectAndLinkButton = ({
  selectAndLinkOptions,
  objectclassUuid,
  hideSelectAndLinkAction,
  selectAndLinkTargetPath,
  variant = 'text',
  disableLinkButton
}: SelectAndLinkButtonProps) => {
  const [, setRequestObjectAreaResetOnNextFetch] = useSiteState<boolean>(
    'request-object-area-reset-on-next-fetch'
  )
  const { getRedirectToObjectclassCallback } = usePersistentSelection()

  const redirectToSelectAndLink =
    objectclassUuid &&
    selectAndLinkOptions &&
    getRedirectToObjectclassCallback({
      targetField: selectAndLinkOptions.targetField,
      targetGroup: selectAndLinkOptions.targetGroup,
      objectclassUuid,
      targetComponent: selectAndLinkOptions.targetComponent,
      selectedOptions: selectAndLinkOptions.selectedOptions,
      targetPath: selectAndLinkTargetPath
    })

  const { t } = useTranslation()

  if (hideSelectAndLinkAction || !redirectToSelectAndLink) {
    return null
  }

  const handleSelectAndLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    if (disableLinkButton) {
      setRequestObjectAreaResetOnNextFetch(true)
    }
    redirectToSelectAndLink()
  }

  if (variant === 'icon') {
    return (
      <Button
        variant='primary'
        heightClass='semiSmall'
        onClick={handleSelectAndLinkClick}
        aria-label={t('data-tables.select-and-link')}
      >
        <Icon iconName='SelectAndRelateSign' icSize='regular' />
      </Button>
    )
  }

  return (
    <Button
      variant='secondary'
      heightClass='semiSmall'
      onClick={handleSelectAndLinkClick}
    >
      {t('data-tables.select-and-link')}
    </Button>
  )
}

export default SelectAndLinkButton
